import { shouldShowPreRegistrationSteps } from "@/lib/affiliation"
import { useInfoLoginData } from "@/services/get-info-login"

export function useAffiliationDetection() {
  const data = useInfoLoginData()
  return data != null ? shouldShowPreRegistrationSteps(data) : false
}
